import React from "react";
import { Segment, Button } from "semantic-ui-react";
import Swal from "sweetalert2";
import { apiViaje } from "../../api/viaje";
import "../../scss/index.scss";
import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../imagenes/Viaje/ConfirmarImporte.json";

const apiviaje = new apiViaje();

export function ViajeConfirmarImporte({ Id, Estado, Destino, Precio, Moneda }) {
  const ConfirmarViaje = async () => {
    const respuesta = await apiviaje.aceptarPrecio(Id);

    if (respuesta.status === 200) {
      Swal.fire({
        title: "Viaje confirmado correctamente",
        text: "",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  };

  const CancelarViaje = async () => {
    const respuesta = await apiviaje.cancelar(Id);

    if (respuesta.status === 200) {
      Swal.fire({
        title: "Viaje cancelado correctamente",
        text: "",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <Segment secondary className="segmentViajeConfirmarImporte">
        Hemos encontrado un vehículo para tu viaje con destino a{" "}
        <b>{Destino}</b>.<br></br>
        El valor propuesto es de: <b>${Precio}</b> pesos.
        <br></br>
        <br></br>
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 120 }}
        />
        <br></br>
        Lo aceptas?
        <br></br>
        <div style={{ textAlign: "Center" }}>
          <Button onClick={(e) => ConfirmarViaje(e)}>Si</Button>
          <Button basic onClick={(e) => CancelarViaje(e)}>
            No
          </Button>
        </div>
      </Segment>
    </div>
  );
}
